import Film from '@/components/Film'
import Person from '@/components/Person'
import Films from '@/components/Films'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Profile from '@/components/Profile'
import Signup from '@/components/Signup'
import People from '@/components/People'
import Brands from '@/components/Brands'
import Products from '@/components/Products'
import Companies from '@/components/Companies'
import Brand from '@/components/Brand'
import Product from '@/components/Product'
import Company from '@/components/Company'
import Awards from '@/components/Awards'
import Award from '@/components/Award'
import Notfound from '@/components/Notfound'
import Searcheroptions from '@/components/Searcheroptions'
export const routes =  [{
    path: '/film/:id',
    component: Film,
    name: 'film',
    props: true,
    meta: {
      targetType: 'film'
    }
  }, {
    path: '/award/:id',
    component: Award,
    name: 'award',
    props: true,
    meta: {
      targetType: 'award'
    }
  }, {
    path: '/person/:id',
    component: Person,
    name: 'person',
    props: true,
    meta: {
      targetType: 'person'
    }
  }, {
    path: '/brand/:id',
    component: Brand,
    name: 'brand',
    props: true,
    meta: {
      targetType: 'brand'
    }
  }, {
    path: '/product/:id',
    component: Product,
    name: 'product',
    props: true,
    meta: {
      targetType: 'product'
    }
  }, {
    path: '/company/:id',
    component: Company,
    name: 'company',
    props: true,
    meta: {
      targetType: 'company'
    }
  }, {
    path: '/awards',
    name: 'awards',
    component: Awards,
    meta: {
      showAppBar: true,
      targetType: 'award'
    }
  }, {
    path: '/companies',
    name: 'companies',
    component: Companies,
    meta: {
      showAppBar: true,
      targetType: 'company'
    }
  }, {
    path: '/films',
    name: 'films',
    component: Films,
    meta: {
      showAppBar: true,
      targetType: 'film'
    }
  }, {
    path: '/brands',
    name: 'brands',
    component: Brands,
    meta: {
      showAppBar: true,
      targetType: 'brand'
    }
  }, {
    path: '/products',
    name: 'products',
    component: Products,
    meta: {
      showAppBar: true,
      targetType: 'product'
    }
  }, {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      skipTracking: true
    }
  }, {
    path: '/logout',
    name: 'logout',
    component: Logout
  }, {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      authRequred: true
    }
  }, {
    path: '/signup',
    name: 'signup',
    component: Signup
  }, {
    path: '/',
    redirect: '/films'
  },
  {
    path: '/people',
    name: 'people',
    component: People,
    meta: {
      showAppBar: true,
      targetType: 'person'
    }
  }, {
    path: '/searcheroptions',
    name: 'searcheroptions',
    component: Searcheroptions,
    meta: {
      showAppBar: false
    }
  }, {
    path: '/:pathMatch(.*)*',
    component: Notfound,
    meta: {
      skipTracking: true
    }
  }]

